module.exports = __webpack_public_path__ + "static/media/instagram.5c2fd5ff.svg";